import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CacheService } from '../../ssr-services/cache/cache.service';

export const destinationHandlerGuard: CanActivateFn = (route) => {
  const destinationSlug = route.params['destination'];
  const cacheService = inject(CacheService);
  const cacheContent = cacheService.cachedContent();
  const router = inject(Router);

  if (!cacheContent || !destinationSlug) {
    return true; // Let the route continue, will show 404
  }

  // Get all countries, regions, and global regions
  const allCountries = cacheContent.cache.singleCountries;
  const allRegions = cacheContent.cache.regions;
  const globalRegions = cacheContent.cache.globalRegions;

  // Search for destination in countries
  const foundCountry = allCountries.find((country) => country.slug === destinationSlug);
  if (foundCountry) {
    // Store destination data in route data for the component to access
    route.data = {
      ...route.data,
      destination: foundCountry,
      regionType: 'country',
    };
    return true; // Allow navigation to continue
  }

  // Search for destination in regions
  const foundRegion = allRegions.find((region) => region.slug === destinationSlug);
  if (foundRegion) {
    // Store destination data in route data for the component to access
    route.data = {
      ...route.data,
      destination: foundRegion,
      regionType: 'region',
    };
    return true; // Allow navigation to continue
  }

  // Search for destination in global regions
  const foundGlobalRegion = globalRegions.find(
    (globalRegion) => globalRegion.slug === destinationSlug
  );
  if (foundGlobalRegion) {
    // Store destination data in route data for the component to access
    route.data = {
      ...route.data,
      destination: foundGlobalRegion,
      regionType: 'global',
    };
    return true; // Allow navigation to continue
  }

  // Destination not found, show 404
  return router.navigate(['/404'], {
    skipLocationChange: true,
    replaceUrl: true,
  });
};
